<!-- show arrows for table for mobile, since the table scrolls left & right -->
<div class="row d-lg-none small">
  <div class="col"
    ><i role="img" class="fa fa-arrow-left" aria-hidden="true"></i
  ></div>
  <div class="col-8 text-center">
    {{ 'bookingModule.moreAvailableHours' | translate }}
    <span class="visually-hidden">{{
      'wcag.scrollLeftRight' | translate
    }}</span>
  </div>
  <div class="col text-end"
    ><i role="img" class="fa fa-arrow-right" aria-hidden="true"></i
  ></div>
</div>

<div class="table-responsive">
  <table class="table bg-white">
    <tbody>
      <tr class="timeLine">
        <td colspan="2" class="stickyCol bg-white"></td>
        <ng-container
          *ngFor="let scheduleSlot of scheduleSlots; let index = index"
        >
          <td
            [attr.colspan]="config.scheduleHeaderWidth"
            *ngIf="index % config.scheduleHeaderWidth == 0"
          >
            <span class="lineAlign">{{ scheduleSlot.title }}</span>
          </td>
        </ng-container>
      </tr>
    </tbody>
    <tbody
      *ngFor="let day of scheduleSlotsByDayAndGroup$ | async"
      class="timeTable-stripes"
    >
      <tr *ngFor="let slotsGroup of day.slotsByGroup">
        <td colspan="2" class="ps-1 bg-white info-col">
          <span class="stick-left">
            {{ (productEntities$ | async)[slotsGroup.name]?.description }}
          </span>
        </td>

        <td colspan="1" *ngFor="let scheduleSlot of slotsGroup.scheduleSlots">
          <serie-proposal-item-schedule-cell
            (onClickBooking)="onBookableSlotClick($event)"
            (onClickSerieProposalItem)="onSerieProposalItemClick($event)"
            [bookableSlots]="scheduleSlot.bookableSlots"
            [showTooltip]="true"
          >
          </serie-proposal-item-schedule-cell>
        </td>
      </tr>
    </tbody>
    <!-- On empty search insert an empty row, visibility is set to collapse -->
    <tbody style="visibility: collapse">
      <tr>
        <td colspan="1" class="stickyCol bg-white"></td>
      </tr>
    </tbody>
    <!-- END of empty row -->
    <tbody>
      <tr class="timeLine timeLine-bottom">
        <td colspan="2" class="stickyCol bg-white"></td>
        <ng-container
          *ngFor="let scheduleSlot of scheduleSlots; let index = index"
        >
          <td
            [attr.colspan]="config.scheduleHeaderWidth"
            *ngIf="index % config.scheduleHeaderWidth == 0"
          >
            <span class="lineAlign">{{ scheduleSlot.title }}</span>
          </td>
        </ng-container>
      </tr>
    </tbody>
  </table>
</div>
